import { AssessmentDetails } from "Assessments";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: ":classplanner_id/weekly",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "teacher-weeklyplanner" */ "./components"),
        import(
          /* webpackChunkName: "teacher-weeklyplanner" */ "WeeklyPlanning/modules/WeeklyPlanningModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "weeklyPlanning",
          reducer,
        });
        const importFromUnitFlowModalReducer = importedModule2.default;
        injectReducer(store, {
          key: "importFromUnitFlow",
          reducer: importFromUnitFlowModalReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentDetails(store)],
});
